export default __webpack_public_path__ + "static/Surprise-3dfa58daa116c36151b1ccbb3f239663.svg";